import { Pressable, Text, View } from 'react-native';
import React from 'react';
import Svg, { G, Path, Defs, ClipPath, Rect } from 'react-native-svg';
// using inline styles as figma is done with new dls which cant be used here 
// these can be reused in new revamp
const SwitchIcon = ({ width = 20, height = 20, color = '#2D57D9' }) => {
    return (React.createElement(Svg, { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none" },
        React.createElement(G, { clipPath: "url(#clip0)" },
            React.createElement(Path, { d: "M11 9L13 11L11 13", stroke: "#2D57D9", strokeWidth: 1.2, strokeLinecap: "round", strokeLinejoin: "round" }),
            React.createElement(Path, { d: "M3 11H13", stroke: "#2D57D9", strokeWidth: 1.2, strokeLinecap: "round", strokeLinejoin: "round" }),
            React.createElement(Path, { d: "M5 7L3 5L5 3", stroke: "#2D57D9", strokeWidth: 1.2, strokeLinecap: "round", strokeLinejoin: "round" }),
            React.createElement(Path, { d: "M13 5H3", stroke: "#2D57D9", strokeWidth: 1.2, strokeLinecap: "round", strokeLinejoin: "round" })),
        React.createElement(Defs, null,
            React.createElement(ClipPath, { id: "clip0" },
                React.createElement(Rect, { width: 16, height: 16, fill: "white" })))));
};
const ElevateHeader = ({ onPress, action, triggerAction, targetPartner }) => {
    const handleAction = () => {
        onPress && onPress();
        action &&
            triggerAction &&
            triggerAction(action);
    };
    return (React.createElement(View, { style: { flexDirection: "row", marginHorizontal: -16, borderTopColor: "#D6E2F2", borderTopWidth: 1, marginTop: -16, marginBottom: 16, backgroundColor: "white", padding: 16, alignItems: "center", justifyContent: "space-between" } },
        React.createElement(View, { style: { flex: 1, height: "100%", flexDirection: "row" } },
            React.createElement(View, { style: { height: "100%", marginRight: 8, width: 8, borderRadius: 2, backgroundColor: "#0071BB" } }),
            React.createElement(View, null,
                React.createElement(Text, { style: { color: "#152130", fontSize: 14, lineHeight: 20, fontWeight: "600" } },
                    "Switch to ",
                    targetPartner ?? ""),
                React.createElement(Text, { style: { color: "#55667C", fontSize: 12, lineHeight: 18, fontWeight: "500", marginTop: 4 } }, "Click on switch to go to other loan"))),
        React.createElement(Pressable, { onPress: handleAction, style: { flexDirection: 'row', alignItems: "center", justifyContent: "center" }, hitSlop: { top: 20, left: 20, right: 20, bottom: 20 } },
            React.createElement(SwitchIcon, null),
            React.createElement(Text, { style: { marginLeft: 4, color: "#2D57D9", fontSize: 16, lineHeight: 24, fontWeight: "600" } }, "Switch"))));
};
export default ElevateHeader;
